import React, { useState, forwardRef, useEffect } from "react";
// import { DayPicker } from "react-day-picker";
// import "react-day-picker/style.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getCacheData, postData, getFreshData } from "../../utils/request";
import "./HFundPrice.css";
const HFP_URL = "/api/hfund_prices/get_h_fund_price_by_date";

function HFundPrice() {
  const [selected, setSelected] = useState();
  const [hFPrice, setHFPrice] = useState(null);
  const [hFPriceData, setHFPriceDate] = useState(new Date());

  const getPrices = async ({ useCache }) => {
    // setStartDate(new Date());

    if (useCache) {
      const hFPrice = await getFreshData(
        HFP_URL + "/" + hFPriceData.toISOString().split("T")[0],
        true,
      );
      // const cachedPrices = getCacheData(HFP_URL + "?date=" + startDate.toISOString().split("T")[0]);
      if (hFPrice) {
        setHFPrice(hFPrice);
      }
    }
    // const newMessage = await postData(MSG_URL, useCache, {
    //   group: "NTHC Ltd",
    // });
    // setMessage(newMessage);
  };
  useEffect(() => {
    getPrices({ useCache: true });
  }, [
    hFPriceData.toLocaleString("en-US", {
      month: "long",
      year: "numeric",
      day: "numeric",
    }),
  ]);
  const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday
  };
  const CustomInput = forwardRef(
    ({ value, onClick, placeholder = "Select a date" }, ref) => (
      <input
        ref={ref}
        value={value || ""}
        onClick={onClick}
        placeholder={placeholder}
        className="custom-input"
        readOnly
        style={{
          padding: ".5rem",
          border: "2px solid white",
          borderRadius: "8px",
          width: "7rem",
          cursor: "pointer",
          backgroundColor: "white",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      />
    ),
  );
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        // justifyContent: "center",
        // alignItems: "center",
        width: "80%",
        // height: "20rem",
        // backgroundColor: "gray",
        marginBottom: "2rem",
        marginTop: "1rem",
      }}
    >
      <div>
        <div
          style={{
            height: "4rem",
            width: "100%",
            backgroundColor: "#25a560",
            paddingLeft: "2rem",
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            color: "white",
            fontSize: "1.2rem",
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "2rem",
            marginBottom: ".1rem",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          }}
        >
          <span style={{ fontSize: "1rem", fontWeight: "bold" }}>
            NTHC HORIZON FUND
          </span>
        </div>
        <div
          style={{
            height: "4rem",
            width: "100%",
            backgroundColor: "#25a560",
            paddingLeft: "2rem",
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            color: "white",
            fontSize: "1.2rem",
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "2rem",
          }}
        >
          <span style={{ fontWeight: "bold" }}>
            As at{" "}
            {hFPrice?.date
              ? new Date(hFPrice?.date).toLocaleString("en-US", {
                  month: "long",
                  year: "numeric",
                  day: "numeric",
                  weekday: "long",
                })
              : hFPriceData.toLocaleString("en-US", {
                  month: "long",
                  year: "numeric",
                  day: "numeric",
                  weekday: "long",
                })}
          </span>
          <span>
            {" "}
            <DatePicker
              // selected={"Pick a date"}
              onChange={(date) => setHFPriceDate(date)}
              customInput={<CustomInput />}
              placeholderText="Select a date"
              filterDate={isWeekday}
            />
          </span>
        </div>
        <table style={{ width: "100%" }}>
          <thead>
            <tr
              style={{
                borderBottom: "0.1px solid gray",
                height: "4rem",
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                textAlign: "center",
              }}
            >
              <th
                style={{
                  textAlign: "left",
                  // marginRight: "3%",
                  // backgroundColor: "red",
                  width: "30%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Net Asset Value (GHS 'M')
              </th>
              <th
                style={{
                  textAlign: "left",
                  // marginRight: "3%",
                  width: "30%",
                  // backgroundColor: "pink",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Year to date
              </th>
              <th
                style={{
                  textAlign: "left",
                  // marginRight: "3%",
                  // backgroundColor: "blue",
                  width: "30%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Price/Unit (GHSp)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              key={"item.id"}
              style={{
                borderBottom: "0.1px solid gray",
                height: "4rem",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                textAlign: "center",
              }}
            >
              <td
                style={{
                  textAlign: "left",
                  // marginRight: "3%",
                  width: "30%",
                  // backgroundColor: "red",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {hFPrice?.net_asset_value ? hFPrice.net_asset_value : "null"}
              </td>
              <td
                style={{
                  textAlign: "left",
                  // marginRight: "3%",
                  // backgroundColor: "pink",
                  width: "30%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {hFPrice?.year_to_date ? hFPrice.year_to_date + "%" : "null"}
              </td>
              <td
                style={{
                  textAlign: "left",
                  // marginRight: "3%",
                  width: "30%",
                  // backgroundColor: "blue",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {hFPrice?.price ? hFPrice.price : "null"}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style={{
            height: "4rem",
            width: "100%",
            backgroundColor: "#25a560",
            paddingLeft: "2rem",
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            color: "white",
            fontSize: "1.2rem",
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "2rem",
            marginBottom: ".1rem",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
          }}
        >
          {/* <span style={{ fontSize: "1rem", fontWeight: "bold" }}>
            NTHC HORIZON FUND
          </span> */}
        </div>
      </div>
    </div>
  );
}

export default HFundPrice;
